<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="x1PART-NUM" id="sec1"><a href="#/text/9780062305589_Contents#sec1"><span class="bold">Section 1</span></a></p>
<p class="x1PART-TTL"><a href="#/text/9780062305589_Contents#sec1"><span class="bold">WHAT’S WRONG WITH CAPITALISM?</span></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062305589_Section_1.vue?19bb80aa